// Фон не прокручивается, пока открыто хоть что-то поверх: карточка, окно, лист.
// Замки считаются: закрыли лист над карточкой — фон всё ещё заперт; закрыли
// последний — прокрутка возвращается такой, какой была до первого замка.
// Порядок закрытия не важен (раньше лист возвращал `hidden` после карточки).

export interface StyleTarget {
  style: { overflow: string }
}

export interface ScrollLock {
  /** Запереть; вернёт функцию, которая снимает именно этот замок (повторно — без эффекта). */
  lock(): () => void
  count(): number
}

export function createScrollLock(target: () => StyleTarget | null): ScrollLock {
  let held = 0
  let saved = ''

  return {
    lock() {
      const el = target()
      if (held === 0 && el) {
        saved = el.style.overflow
        el.style.overflow = 'hidden'
      }
      held += 1
      let released = false
      return () => {
        if (released) return
        released = true
        held -= 1
        const now = target()
        if (held === 0 && now) now.style.overflow = saved
      }
    },
    count: () => held,
  }
}
